import { AiDashboardCard } from '@/features/dashboard/components/dashboard/ai-dashboard-card';
import { KpiLatestEntriesSection } from '@/features/dashboard/components/dashboard/kpi-latest-entries-section';
import { ProjectSlideCards } from '@/features/dashboard/components/dashboard/project-slide-cards';
import { DefaultLayout } from '@/shared/components/layouts/default-layout';

const OverviewPageContent = () => {
  return (
    <DefaultLayout>
      <div className="flex h-full w-full flex-col gap-6">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-[2fr,1fr] md:gap-6">
          <ProjectSlideCards />
          <AiDashboardCard />
        </div>
        <KpiLatestEntriesSection />
      </div>
    </DefaultLayout>
  );
};

const OverviewPage = () => {
  return <OverviewPageContent />;
};

export default OverviewPage;
